/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useMemo } from "react";
import { Grid, Card } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import axios from "axios";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import { useMaterialUIController } from "context";
import { CalendarToday } from "@mui/icons-material";
import MapComponent from "./Components/MapComponent";
import ModeEditOutlineIcon from "@mui/icons-material/ModeEditOutline";
import CustomMaterialTablePage from "../../components/custom/CustomMaterialTablePage";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Loader from "components/custom/Loader";
import { Tooltip } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import PopAddVehicle from "./Popaddvehicle";
import useApiRequest from "utils/Apirequest";
import { AutoTooltip } from "utils/Constant";
import { getDecodedUserData } from "utils/Constant";
import totalChargerImage from "../../assets/cms-icons/Totalcharger.png"
import BulkUploadDialog from "components/BulkUpload/BulkUploadDialog";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import MapIcon from "@mui/icons-material/Map";
import SatelliteAltIcon from "@mui/icons-material/SatelliteAlt";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import GetAppIcon from '@mui/icons-material/GetApp';


function Vehicle_mgmt() {
  const apiRequest = useApiRequest();

  const getValues = () => {
    return {
      tag_id: "",

      charger_id: "",
      vehicleId: "",
      connectorId: "",
    };
  };

  const [locations, setLocations] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [isDisabled, setIsDisabled] = useState(false);
  const [values] = useState(getValues);
  const [columnFilters, setColumnFilters] = useState([]);
  const [clearMapSelection, setClearMapSelection] = useState(0);
  const [bulkUploadOpen, setBulkUploadOpen] = useState(false);

  const [mapMode, setMapMode] = useState("map");

  const [mapCenter, setMapCenter] = useState({
    lat: 25.2048,   // Dubai
    lng: 55.2708,
  });

  const [mapZoom, setMapZoom] = useState(11);
  const [mapSearch, setMapSearch] = useState("");
  const [filteredVehicles, setFilteredVehicles] = useState([]);
  const handleMapSearch = (value) => {
    setMapSearch(value);

    if (!value.trim()) {
      setFilteredVehicles([]);
      return;
    }

    const query = value.toLowerCase();

    const matches = locations.filter((vehicle) =>
      [vehicle.name, vehicle.vin, vehicle?.driver?.staffId]
        .filter(Boolean)
        .some((field) => field.toLowerCase().includes(query))
    );

    setFilteredVehicles(matches);

    // Auto-zoom if exactly one match
    if (matches.length === 1) {
      zoomToVehicle(matches[0]);
    }
  };

  const handleDownloadVehiclesExcel = async () => {
    try {
      const { data } = (await apiRequest(
        "get",
        `vehicle?page=1&limit=100000&sortField=createdAt&sortOrder=desc&search=`,
        null,
        {},
        {},
        false
      )) || {};
  
      if (!data?.success || !data?.data?.length) {
        console.error("No vehicle data available!");
        return;
      }
  
      const vehicles = data.data;
      const workbook = new ExcelJS.Workbook();
      const sheet = workbook.addWorksheet("Vehicles");
  
      const headers = [
        "Vehicle Reg",
        "Make",
        "Model",
        "Variant",
        "Type",
        "Battery Capacity (kWh)",
        "Connector Type",
        "Claimed Range (km)",
        "VIN",
        "VID"
      ];
  
      const headerRow = sheet.addRow(headers);
  
      headerRow.font = { bold: true };
      headerRow.alignment = { horizontal: "center" };
      headerRow.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFE082" },
        };
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
      });
  
      vehicles.forEach((vehicle) => {
        const row = sheet.addRow([
          vehicle.vehicle_reg ?? "",
          vehicle.make ?? "",
          vehicle.model ?? "",
          vehicle.variant ?? "",
          vehicle.type ?? "",
          vehicle.battery_capacity ?? "",
          vehicle.connector_type ?? "",
          vehicle.claimed_range ?? "",
          vehicle.vin ?? "",
          vehicle.vid ?? "N/A",
        ]);
  
        row.eachCell((cell) => {
          cell.alignment = { horizontal: "center" };
          cell.border = {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          };
        });
      });
  
      sheet.columns.forEach((col) => (col.width = 22));
  
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
  
      saveAs(blob, `Vehicles_list.xlsx`);
    } catch (error) {
      console.error("Failed to download vehicles Excel:", error);
    }
  };

  const zoomToVehicle = (vehicle) => {
    const lat = vehicle?.position?.lat;
    const lng = vehicle?.position?.lng;

    if (!lat || !lng) return;

    setMapCenter({ lat, lng });
    setMapZoom(16);
  };

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });

  useEffect(() => {
    setPage(pagination.pageIndex);
    setPageSize(pagination.pageSize);
  }, [pagination]);

  const [page, setPage] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [sorting, setSorting] = useState([
    {
      id: "createdAt",
      desc: true,
    },
  ]);
  const [pageSize, setPageSize] = useState(20);
  const [totalRows, setTotalRows] = useState(0);
  const [columnVisibility, setColumnVisibility] = useState({
    claimed_range: false,
    connector_type: false,
  });
  const [isLocationLoading, setIsLocationLoading] = useState(true);

  const handleStateChange = (newState) => {
    setIsDisabled(newState);
  };

  const handleSortingChange = (newSorting) => {
    setSorting(newSorting);
  };

  const handleSearchChange = (value) => {
    const searchValue =
      typeof value === "string"
        ? value
        : value?.target?.value ?? "";

    setSearchText(searchValue);
    setPage(0);
  };

  useEffect(() => {
    if (getDecodedUserData()?.login_status !== "true") {
      navigate("/sign-in");
    }
    (async () => {
      const { data } =
        (await apiRequest(
          "get",
          `vehicle?page=${page + 1}&limit=${pageSize}&sortField=${sorting[0]?.id || ""
          }&sortOrder=${sorting[0]?.desc ? "desc" : "asc"
          }&search=${searchText}`,
          null,
          {},
          {}
        )) || {};
      if (data?.success === true) {
        const sortedRows = data?.data?.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setRows(sortedRows);
        setTotalRows(data?.total);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    })();
  }, [page, pageSize, sorting, searchText]);

  useEffect(() => {
    const fetchVehicleData = async () => {
      setIsLocationLoading(true);

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASEURL}vehicle/get-location`,
          {
            withCredentials: true,
          }
        );

        if (response.data?.success) {
          setLocations(response.data.data || []);
        } else {
          enqueueSnackbar(
            response?.data?.message || "Some issue while fetching vehicles.",
            { variant: "error" }
          );
        }
      } catch (error) {
        enqueueSnackbar("Failed to fetch vehicle locations.", {
          variant: "error",
        });
        console.error(error);
      } finally {
        setIsLocationLoading(false);
      }
    };

    fetchVehicleData();
    const intervalId = setInterval(fetchVehicleData, 60000);

    return () => clearInterval(intervalId);
  }, []);

  const MOVING_THRESHOLD = 3;

  const speedSummary = useMemo(() => {
    const summary = {
      moving: 0,
      idle: 0,
      stopped: 0,
      total: locations.length,
    };

    locations.forEach((v) => {
      const speed = Number(v.speed) || 0;
      const engine = (v.engineStatus || "").toLowerCase();

      if (speed > MOVING_THRESHOLD) {
        summary.moving++;
      } else if (speed === 0 && engine === "on") {
        summary.idle++;
      } else if (speed === 0 && engine === "off") {
        summary.stopped++;
      } else {
        // speeds between 1 and 5 can be treated as idle or moving depending on requirement
        summary.idle++;
      }
    });

    return summary;
  }, [locations]);


  const handleEdit = (row_data) => {
    navigate("/vehicle/edit", { state: row_data?._id });
  };

  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const { sidenavColor } = controller;

  const { enqueueSnackbar } = useSnackbar();
  const [rows, setRows] = useState([]);
  const navigate = useNavigate();
  const start = (event) => {
    event.preventDefault();
    setIsDisabled(!isDisabled);
  };

  const [columns, setColumns] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const column = [
    {
      header: "Vehicle Reg ",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      size: 10,
      accessorKey: "vehicle_reg",
      align: "center",
      Cell: ({ cell }) => {
        const reg = cell.getValue() || "";
        return <AutoTooltip maxWidth={150}>{reg}</AutoTooltip>;
      },
    },
    {
      header: "VIN",
      accessorKey: "vin",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      size: 10,
      Cell: ({ cell }) => cell.getValue() || "N/A",
    },
    {
      header: "VID",
      accessorKey: "vid",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      size: 10,
      Cell: ({ cell }) => cell.getValue() || "N/A",
    },
    {
      header: "Make",
      accessorKey: "make",
      enableColumnFilter: false,
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
      size: 10,
      Cell: ({ row }) => {
        const { make, model, variant } = row.original;
        return (
          <AutoTooltip maxWidth={150}>{`${make || ""} ${model || ""} ${variant || ""
            }`}</AutoTooltip>
        );
      },
    },
    {
      header: "Battery (kW)",
      accessorKey: "battery_capacity",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      size: 10,
      align: "center",
      Cell: ({ cell }) => {
        const data = cell.getValue();
        return data ? data : "N/A";
      },
    },

    {
      header: "Connector Type",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      accessorKey: "connector_type",
      id: "connector_type",
      align: "center",
    },
    {
      header: "Claimed Range (KM)",
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      accessorKey: "claimed_range",
      align: "center",
      id: "claimed_range",
    },
    {
      header: "Action",
      enableColumnFilter: false,
      muiTableHeadCellProps: {
        align: "center",
      },
      size: 10,
      muiTableBodyCellProps: {
        align: "center",
      },
      accessorKey: "action",
      align: "center",
      Cell: (row) =>
        row.row.depth === 0 ? (
          <div
            style={{
              position: "sticky",
              right: "0",
            }}
          >
            <Tooltip title="Edit Vehicle">
              <MDButton
                onClick={(e) => handleEdit(row.row.original)}
                variant="gradient"
                color={sidenavColor}
                iconOnly
              >
                <ModeEditOutlineIcon />
              </MDButton>
            </Tooltip>
          </div>
        ) : null,
    },
  ];
  useEffect(() => {
    setColumns(column);
  }, []);
  return (
    <DashboardLayout>
      <PopAddVehicle
        isDialog={isDisabled}
        onClose={setIsDisabled}
        value={values}
        onStateChange={handleStateChange}
      />
      <BulkUploadDialog
        open={bulkUploadOpen}
        onClose={() => setBulkUploadOpen(false)}
        moduleName="vehicle"
        onUploadSuccess={() => {
          // Refresh table after upload
          setPage(0);
          setIsLoading(true);
        }}
      />

      <DashboardNavbar />
      <MDBox mt={2} px={2}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                title="Total Vehicles"
                imgicon={totalChargerImage}
                color="dark"
                count={
                  isLocationLoading ? (
                    <CircularProgress size={24} sx={{ color: "#1976d2" }} />
                  ) : (
                    speedSummary.total
                  )
                }
              />
            </MDBox>
          </Grid>
          {/* Moving */}
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                icon="directions_car"
                title="In Transit"
                color="warning"
                count={
                  isLocationLoading ? (
                    <CircularProgress size={24} sx={{ color: "#ed6c02" }} />
                  ) : (
                    speedSummary.moving
                  )
                }
                percentage={{
                  color: "dark",
                  amount: `${(
                    (speedSummary.moving / Math.max(1, speedSummary.total)) *
                    100
                  ).toFixed(0)}%`,
                  label: "of total",
                }}
              />
            </MDBox>
          </Grid>

          {/* Stopped */}
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                icon="pause_circle"
                title="Stopped"
                color="success"
                count={
                  isLocationLoading ? (
                    <CircularProgress size={24} sx={{ color: "#1976d2" }} />
                  ) : (
                    speedSummary.stopped
                  )
                }
                percentage={{
                  color: "dark",
                  amount: `${(
                    (speedSummary.stopped / Math.max(1, speedSummary.total)) *
                    100
                  ).toFixed(0)}%`,
                  label: "of total",
                }}
              />
            </MDBox>
          </Grid>

          {/* idle */}
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                icon="stop_circle"
                title="Idle"
                color="info"
                count={
                  isLocationLoading ? (
                    <CircularProgress size={24} sx={{ color: "#cea141ff" }} />
                  ) : (
                    speedSummary.idle
                  )
                }
                percentage={{
                  color: "dark",
                  amount: `${(
                    (speedSummary.idle / Math.max(1, speedSummary.total)) *
                    100
                  ).toFixed(0)}%`,
                  label: "of total",
                }}
              />
            </MDBox>
          </Grid>

          {/* Low Battery */}
          {/* <Grid item xs={12} sm={6} md={4} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                icon="battery_1_bar"
                title="Low Battery"
                count={
                  isLocationLoading ? (
                    <CircularProgress size={24} sx={{ color: "#1976d2" }} />
                  ) : (
                    batterySummary.low
                  )
                }
                color="error"
                percentage={{
                  color: "error",
                  amount: `${(
                    (batterySummary.low / Math.max(1, batterySummary.total)) *
                    100
                  ).toFixed(0)}%`,
                  label: "vehicles below 20% charge",
                }}
              />
            </MDBox>
          </Grid> */}
        </Grid>
      </MDBox>

      <MDBox
        sx={{
          mt: 3,          // small top spacing
          position: "relative",
          height: "80vh",
          borderRadius: "12px",
          overflow: "hidden",
        }}
      >

        {/* Search Overlay */}
        <MDBox
          sx={{
            position: "absolute",
            top: 16,
            left: 16,
            zIndex: 10,
            width: 320,
          }}
        >
          {/* Search Input */}
          <MDBox
            sx={{
              p: 1.5,
              position: "relative",
            }}
          >
            <input
              placeholder="Search by Vehicle Reg / VIN / Driver ID"
              value={mapSearch}
              onChange={(e) => handleMapSearch(e.target.value)}
              style={{
                width: "100%",
                padding: "10px 38px 10px 14px",
                borderRadius: "10px",
                border: "1px solid #e0e0e0",
                fontSize: "14px",
                fontWeight: 500,
                backgroundColor: "#ffffff",
                boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                transition: "all 0.25s ease",
                outline: "none",
              }}
              onFocus={(e) => {
                e.target.style.border = "1px solid #EC4B48";
                e.target.style.boxShadow = "0 0 0 3px rgba(236,75,72,0.15)";
              }}
              onBlur={(e) => {
                e.target.style.border = "1px solid #e0e0e0";
                e.target.style.boxShadow = "0 2px 6px rgba(0,0,0,0.05)";
              }}
            />


            {/* Clear Button */}
            {mapSearch && (
              <span
                onClick={() => {
                  setMapSearch("");
                  setFilteredVehicles([]);
                  setSelectedVehicle(null);
                  setMapCenter({ lat: 25.2048, lng: 55.2708 });
                  setMapZoom(15);
                  setClearMapSelection((v) => v + 1); // trigger map clear
                }}
                style={{
                  position: "absolute",
                  right: 24,
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  fontSize: "16px",
                  color: "#888",
                  userSelect: "none",
                }}
                title="Clear"
              >
                ✕
              </span>
            )}

          </MDBox>

          {/* Dropdown Results */}
          {filteredVehicles.length > 0 && (
            <MDBox
              sx={{
                mt: 1,
                maxHeight: 220,
                overflowY: "auto",
                backgroundColor: "#fff",
                borderRadius: "10px",
                boxShadow: "0 10px 24px rgba(0,0,0,0.18)",
              }}
            >

              {filteredVehicles.map((v, index) => (
                <MDBox
                  key={index}
                  onClick={() => {
                    setMapSearch(v.name);        // Fill input
                    setFilteredVehicles([]);    // Close dropdown
                    setSelectedVehicle(v);      // Tell map which vehicle
                    zoomToVehicle(v);           // Pan + zoom
                  }}
                  sx={{
                    px: 2,
                    py: 1.2,
                    cursor: "pointer",
                    transition: "background 0.2s",
                    "&:hover": {
                      backgroundColor: "#f5f7fa",
                    },
                  }}
                >
                  <MDTypography
                    variant="button"
                    fontWeight="bold"
                    sx={{ lineHeight: 1.2 }}
                  >
                    {v.name}
                  </MDTypography>

                  <MDTypography
                    variant="caption"
                    color="text.secondary"
                    sx={{ display: "block" }}
                  >
                    VIN: {v.vin}
                  </MDTypography>
                  <MDTypography
                    variant="caption"
                    color="text.secondary"
                    sx={{ display: "block" }}
                  >
                    Driver ID: {v?.driver?.staffId}
                  </MDTypography>
                </MDBox>
              ))}
            </MDBox>
          )}
        </MDBox>
        {/* Map Mode Toggle */}
        <MDBox
          sx={{
            position: "absolute",
            top: 16,
            right: 16,
            zIndex: 10,
          }}
        >
          <MDBox
            sx={{
              position: "relative",
              display: "flex",
              alignItems: "center",
              backgroundColor: "#ffffff",
              borderRadius: "10px",
              padding: "4px",
              boxShadow: "0 6px 14px rgba(0,0,0,0.12)",
              width: 200,
              overflow: "hidden",
            }}
          >
            {/* Sliding Active Background */}
            <MDBox
              sx={{
                position: "absolute",
                top: 4,
                left: mapMode === "map" ? 4 : "calc(50% - 2px)",
                width: "calc(50% - 4px)",
                height: "calc(100% - 8px)",
                backgroundColor: "#EC4B48",
                borderRadius: "8px",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                boxShadow: "0 3px 8px rgba(236,75,72,0.35)",
              }}
            />


            {/* MAP */}
            <MDBox
              onClick={() => setMapMode("map")}
              sx={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "6px",
                py: 0.75,
                fontSize: "13px",
                fontWeight: 600,
                cursor: "pointer",
                zIndex: 1,
                color: mapMode === "map" ? "#fff" : "#555",
                transition: "color 0.25s ease",
              }}
            >
              <MapIcon sx={{ fontSize: 16 }} />
              Map
            </MDBox>

            {/* SATELLITE */}
            <MDBox
              onClick={() => setMapMode("satellite")}
              sx={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "6px",
                py: 0.75,
                fontSize: "13px",
                fontWeight: 600,
                cursor: "pointer",
                zIndex: 1,
                color: mapMode === "satellite" ? "#fff" : "#555",
                transition: "color 0.25s ease",
              }}
            >
              <SatelliteAltIcon sx={{ fontSize: 16 }} />
              Satellite
            </MDBox>
          </MDBox>
        </MDBox>

        {/* Map */}
        <MapComponent
          locations={locations}
          center={mapCenter}
          zoom={mapZoom}
          selectedVehicle={selectedVehicle}
          clearSelection={clearMapSelection}
          givenHeight="100%"
          mapMode={mapMode}
        />

      </MDBox>

      <MDBox pt={8} pb={4}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={1}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow={sidenavColor}
              >
                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <MDTypography
                    variant="h6"
                    color="white"
                    style={{
                      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                      fontWeight: "600",
                      width: "50%",
                    }}
                  >
                    Vehicle Management
                  </MDTypography>

                  <MDBox
                    className="admin_btnsHeaderCont"
                    style={{
                      display: "flex",

                      justifyContent: "space-between",
                    }}
                  >
                    <MDBox sx={{ display: "flex", alignItems: "center" }}>
                      <MDBox sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <MDButton
                          onClick={() => handleDownloadVehiclesExcel()}
                          size="small"
                          variant="outlined"
                          color="white"
                          startIcon={<GetAppIcon />}
                        >
                          Export Vehicles
                        </MDButton>
                        <MDButton
                          onClick={() => setBulkUploadOpen(true)}
                          size="small"
                          variant="outlined"
                          color="white"
                          startIcon={<UploadFileIcon />}
                        >
                          Bulk Upload
                        </MDButton>
                        <MDButton
                          onClick={start}
                          size="small"
                          variant="outlined"
                          color="white"
                          startIcon={<CalendarToday />}
                        >
                          Add Vehicle
                        </MDButton>


                      </MDBox>

                    </MDBox>
                  </MDBox>
                </Grid>
              </MDBox>
              {isLoading ? (
                <Loader />
              ) : (
                <CustomMaterialTablePage
                  columns={columns}
                  data={rows}
                  darkMode={darkMode}
                  manualPagination={true}
                  manualFiltering={false}
                  rowCount={totalRows}
                  paginationChange={(newPage) => setPagination(newPage)}
                  initialState={{
                    columnVisibility: {
                      claimed_range: false,
                      connector_type: false,
                    },
                  }}
                  soringChange={handleSortingChange}
                  page={page}
                  pagesize={pageSize}
                  paginataion={pagination}
                  sorting={sorting}
                  searchText={searchText}
                  searchChange={handleSearchChange}
                  onColumnFiltersChange={setColumnFilters}
                  onColumnVisibilityChange={setColumnVisibility}
                  state={{
                    pagination,
                    sorting,

                    columnFilters,
                    columnVisibility,
                  }}
                  globalFilterDebounceMs={2000}
                />
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default Vehicle_mgmt;
